module.exports = __webpack_public_path__ + "static/media/channel=chatbot.cc816572.svg";